require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reviews-oakley-wtr-icon-helmet.json") })
        }
      }, "path---reviews-oakley-wtr-icon-helmet");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reviews-oakley-wtr-icon-helmet!./.cache/json/reviews-oakley-wtr-icon-helmet.json
// module id = 691
// module chunks = 231608221292675